import { Injectable } from '@angular/core';
import { AlertController, NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private alertController: AlertController, private navController: NavController) { }


  async showAlert(text: string, islogin?: boolean, title?: string) {
    if(islogin){
      const alert = await this.alertController.create({
        header: title ? title : 'Attenzione',
        message: text,
        buttons: [
          {
            text: "Login",
            handler: () => {
              // this.navController.navigateBack("/auth/login");
            }
          }
        ],
        mode: "ios"
      });
      await alert.present();
      return;
    }
    const alert = await this.alertController.create({
      header: title ? title : 'Attenzione',
      message: text,
      buttons: ['OK'],
      mode: "ios"
    });

    await alert.present();
  }


  /**
   * Traduce un errore HTTP in un messaggio adatto all'utente.
   * - rete/server irraggiungibile (status 0) → messaggio di connessione
   * - 5xx → messaggio generico (non espone i dettagli interni del server)
   * - 4xx → messaggio del server (pensato per l'utente), con fallback
   */
  apiErrorMessage(error: any): string {
    if (!error || error.status === 0) {
      return "Impossibile contattare il server. Controlla la connessione e riprova.";
    }
    if (error.status >= 500) {
      return "Si è verificato un errore del server. Riprova più tardi.";
    }
    return error.error?.message || "Si è verificato un errore. Riprova.";
  }

  /** Mostra un alert a partire da un errore HTTP, usando apiErrorMessage(). */
  async showApiError(error: any, islogin?: boolean, title?: string) {
    await this.showAlert(this.apiErrorMessage(error), islogin, title);
  }


  async showAlertOptions(text: string) {
    const alert = await this.alertController.create({
      header: 'Attenzione',
      message: text,
      buttons: [
        {
          text: 'CANCEL',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
          }
        }, {
          text: 'OK',
          handler: () => {
          }
        }
      ]
    });
  
    await alert.present();
  }
}
